import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  const w = window as any;
  if (w._fbPixelInitialized) return;
  w._fbPixelInitialized = true;
  const fbq: any = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  };
  w.fbq = fbq;
  w._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
  fbq('init', '1136780540633633');
  fbq('track', 'PageView');
  // Noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1136780540633633&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.head.appendChild(noscript);
})();
render(<App data-id="element-429" />, document.getElementById('root'));